import React, { useEffect, useRef, useState } from 'react'
import grapesjs from 'grapesjs'
import 'grapesjs/dist/css/grapes.min.css'
import {
  Box,
  Paper,
  Typography,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  AppBar,
  Toolbar,
  IconButton,
  Tabs,
  Tab,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Switch,
  FormControlLabel,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Card,
  CardContent,
  Tooltip,
  Badge,
  Fab,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  Alert,
  Snackbar
} from '@mui/material'
import {
  Email,
  TextFields,
  Image,
  SmartButton,
  ViewColumn,
  Layers,
  Style,
  GetApp,
  Clear,
  Preview,
  Send,
  Save,
  Undo,
  Redo,
  PhotoLibrary,
  Code,
  Palette,
  Devices,
  Timeline,
  Settings,
  Reorder,
  Analytics,
  PersonAdd,
  Schedule,
  AttachFile,
  FormatBold,
  FormatItalic,
  FormatUnderlined,
  Link,
  List as ListIcon,
  ViewModule,
  TableChart,
  Remove as DividerIcon,
  Business,
  Star,
  MenuOpen,
  Close,
  CloudUpload,
  Smartphone,
  Tablet,
  Computer,
  MoreVert
} from '@mui/icons-material'

const AdvancedEmailBuilder = () => {
  const editorRef = useRef(null)
  const [editor, setEditor] = useState(null)
  const [rightPanelOpen, setRightPanelOpen] = useState(true)
  const [leftPanelOpen, setLeftPanelOpen] = useState(true)
  const [activeTab, setActiveTab] = useState(0)
  const [previewMode, setPreviewMode] = useState('desktop')
  const [templateDialogOpen, setTemplateDialogOpen] = useState(false)
  const [saveDialogOpen, setSaveDialogOpen] = useState(false)
  const [sendDialogOpen, setSendDialogOpen] = useState(false)
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('')
  const [emailSettings, setEmailSettings] = useState({
    subject: 'Your Email Subject',
    preheader: 'Preview text that appears in inbox',
    fromName: 'Your Company',
    fromEmail: 'hello@yourcompany.com'
  })

  const templates = [
    {
      id: 'newsletter',
      name: 'Newsletter',
      description: 'Modern newsletter template',
      preview: '/api/placeholder/300/200',
      content: `
        <div style="max-width: 600px; margin: 0 auto; font-family: Arial, sans-serif; background: #ffffff;">
          <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 40px 20px; text-align: center;">
            <h1 style="color: white; margin: 0; font-size: 32px; font-weight: 300;">Weekly Newsletter</h1>
            <p style="color: rgba(255,255,255,0.9); margin: 10px 0 0 0; font-size: 16px;">Stay updated with our latest news</p>
          </div>
          <div style="padding: 40px 20px;">
            <h2 style="color: #333; font-size: 24px; margin-bottom: 20px;">Latest Updates</h2>
            <p style="color: #666; line-height: 1.6; font-size: 16px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            <div style="text-align: center; margin: 30px 0;">
              <a href="#" style="background: #667eea; color: white; padding: 15px 30px; text-decoration: none; border-radius: 50px; display: inline-block; font-weight: bold;">Read More</a>
            </div>
          </div>
          <div style="background: #f8f9fa; padding: 30px 20px; text-align: center; border-top: 1px solid #eee;">
            <p style="color: #999; font-size: 14px; margin: 0;">&copy; 2024 Your Company. All rights reserved.</p>
          </div>
        </div>
      `
    },
    {
      id: 'promotion',
      name: 'Promotional',
      description: 'Eye-catching promotional email',
      preview: '/api/placeholder/300/200',
      content: `
        <div style="max-width: 600px; margin: 0 auto; font-family: Arial, sans-serif; background: #ffffff;">
          <div style="background: linear-gradient(45deg, #ff6b6b, #ee5a24); padding: 50px 20px; text-align: center;">
            <h1 style="color: white; margin: 0; font-size: 36px; font-weight: bold;">SPECIAL OFFER</h1>
            <p style="color: white; font-size: 20px; margin: 15px 0;">Save 50% on all products!</p>
            <div style="background: rgba(255,255,255,0.2); border-radius: 10px; padding: 15px; margin: 20px 0; display: inline-block;">
              <span style="color: white; font-size: 24px; font-weight: bold;">Use Code: SAVE50</span>
            </div>
          </div>
          <div style="padding: 40px 20px; text-align: center;">
            <h2 style="color: #333; font-size: 28px; margin-bottom: 20px;">Limited Time Only</h2>
            <p style="color: #666; line-height: 1.6; font-size: 16px; margin-bottom: 30px;">Don't miss out on this incredible opportunity to save big on our premium products.</p>
            <a href="#" style="background: linear-gradient(45deg, #ff6b6b, #ee5a24); color: white; padding: 20px 40px; text-decoration: none; border-radius: 50px; display: inline-block; font-weight: bold; font-size: 18px; box-shadow: 0 4px 15px rgba(255,107,107,0.3);">Shop Now</a>
          </div>
        </div>
      `
    },
    {
      id: 'welcome',
      name: 'Welcome',
      description: 'Welcome new subscribers',
      preview: '/api/placeholder/300/200',
      content: `
        <div style="max-width: 600px; margin: 0 auto; font-family: Arial, sans-serif; background: #ffffff;">
          <div style="background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%); padding: 50px 20px; text-align: center;">
            <div style="background: white; width: 80px; height: 80px; border-radius: 50%; margin: 0 auto 20px; display: flex; align-items: center; justify-content: center;">
              <span style="font-size: 40px;">👋</span>
            </div>
            <h1 style="color: white; margin: 0; font-size: 32px; font-weight: 300;">Welcome!</h1>
            <p style="color: rgba(255,255,255,0.9); margin: 15px 0 0 0; font-size: 18px;">We're excited to have you on board</p>
          </div>
          <div style="padding: 40px 20px;">
            <h2 style="color: #333; font-size: 24px; text-align: center; margin-bottom: 30px;">Get Started</h2>
            <div style="background: #f8f9fa; border-radius: 10px; padding: 30px; margin-bottom: 30px;">
              <h3 style="color: #333; margin-top: 0;">What's Next?</h3>
              <ul style="color: #666; line-height: 1.8;">
                <li>Complete your profile setup</li>
                <li>Explore our latest features</li>
                <li>Join our community forum</li>
              </ul>
            </div>
            <div style="text-align: center;">
              <a href="#" style="background: #74b9ff; color: white; padding: 15px 30px; text-decoration: none; border-radius: 50px; display: inline-block; font-weight: bold; margin-right: 15px;">Complete Setup</a>
              <a href="#" style="border: 2px solid #74b9ff; color: #74b9ff; padding: 13px 30px; text-decoration: none; border-radius: 50px; display: inline-block; font-weight: bold;">Learn More</a>
            </div>
          </div>
        </div>
      `
    }
  ]

  const advancedBlocks = [
    {
      category: 'Layout',
      items: [
        { id: 'hero-section', label: 'Hero Section', icon: <ViewModule />, content: '<div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 60px 20px; text-align: center; color: white;"><h1 style="font-size: 48px; margin: 0;">Hero Title</h1><p style="font-size: 20px; margin: 20px 0;">Compelling subtitle goes here</p><a href="#" style="background: white; color: #667eea; padding: 15px 30px; text-decoration: none; border-radius: 50px; font-weight: bold; display: inline-block;">Get Started</a></div>' },
        { id: 'two-column', label: 'Two Columns', icon: <ViewColumn />, content: '<div style="display: flex; max-width: 100%;"><div style="flex: 1; padding: 20px; margin-right: 10px; background: #f8f9fa;"><h3>Column 1</h3><p>Your content here...</p></div><div style="flex: 1; padding: 20px; margin-left: 10px; background: #f8f9fa;"><h3>Column 2</h3><p>Your content here...</p></div></div>' },
        { id: 'three-column', label: 'Three Columns', icon: <ViewColumn />, content: '<div style="display: flex; max-width: 100%;"><div style="flex: 1; padding: 15px; margin: 0 5px; background: #f8f9fa; text-align: center;"><h4>Column 1</h4><p>Content</p></div><div style="flex: 1; padding: 15px; margin: 0 5px; background: #f8f9fa; text-align: center;"><h4>Column 2</h4><p>Content</p></div><div style="flex: 1; padding: 15px; margin: 0 5px; background: #f8f9fa; text-align: center;"><h4>Column 3</h4><p>Content</p></div></div>' },
        { id: 'spacer', label: 'Spacer', icon: <DividerIcon />, content: '<div style="height: 40px; background: transparent;"></div>' }
      ]
    },
    {
      category: 'Content',
      items: [
        { id: 'heading', label: 'Heading', icon: <TextFields />, content: '<h2 style="color: #333; font-size: 28px; margin: 20px 0; font-weight: 600;">Your Heading</h2>' },
        { id: 'paragraph', label: 'Paragraph', icon: <TextFields />, content: '<p style="color: #666; line-height: 1.6; font-size: 16px; margin: 15px 0;">Your paragraph text goes here. You can write about anything you want to share with your subscribers.</p>' },
        { id: 'image-text', label: 'Image + Text', icon: <PhotoLibrary />, content: '<div style="display: flex; align-items: center; margin: 30px 0;"><img src="https://via.placeholder.com/150x150" style="width: 150px; height: 150px; border-radius: 10px; margin-right: 20px;"><div><h3 style="margin: 0 0 10px 0; color: #333;">Feature Title</h3><p style="margin: 0; color: #666; line-height: 1.5;">Description of your feature or product goes here.</p></div></div>' },
        { id: 'testimonial', label: 'Testimonial', icon: <Star />, content: '<div style="background: #f8f9fa; border-left: 4px solid #667eea; padding: 30px; margin: 30px 0; border-radius: 0 10px 10px 0;"><p style="font-style: italic; color: #555; font-size: 18px; margin: 0 0 15px 0;">"This is an amazing product that has transformed our business!"</p><div style="display: flex; align-items: center;"><div style="width: 50px; height: 50px; background: #667eea; border-radius: 50%; margin-right: 15px; display: flex; align-items: center; justify-content: center; color: white; font-weight: bold;">JD</div><div><strong style="color: #333;">John Doe</strong><br><small style="color: #999;">CEO, Company Inc.</small></div></div></div>' }
      ]
    },
    {
      category: 'Interactive',
      items: [
        { id: 'cta-button', label: 'CTA Button', icon: <SmartButton />, content: '<div style="text-align: center; margin: 30px 0;"><a href="#" style="background: linear-gradient(45deg, #667eea, #764ba2); color: white; padding: 18px 36px; text-decoration: none; border-radius: 50px; font-weight: bold; font-size: 16px; display: inline-block; box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3); transition: transform 0.2s;">Call to Action</a></div>' },
        { id: 'social-icons', label: 'Social Icons', icon: <Link />, content: '<div style="text-align: center; margin: 30px 0;"><a href="#" style="display: inline-block; margin: 0 10px; width: 40px; height: 40px; background: #3b5998; border-radius: 50%; text-align: center; line-height: 40px; color: white; text-decoration: none;">f</a><a href="#" style="display: inline-block; margin: 0 10px; width: 40px; height: 40px; background: #1da1f2; border-radius: 50%; text-align: center; line-height: 40px; color: white; text-decoration: none;">t</a><a href="#" style="display: inline-block; margin: 0 10px; width: 40px; height: 40px; background: #0077b5; border-radius: 50%; text-align: center; line-height: 40px; color: white; text-decoration: none;">in</a></div>' },
        { id: 'product-card', label: 'Product Card', icon: <Business />, content: '<div style="border: 1px solid #e0e0e0; border-radius: 15px; overflow: hidden; margin: 20px 0; background: white; box-shadow: 0 4px 20px rgba(0,0,0,0.1);"><img src="https://via.placeholder.com/300x200" style="width: 100%; height: 200px; object-fit: cover;"><div style="padding: 25px;"><h3 style="margin: 0 0 10px 0; color: #333; font-size: 20px;">Product Name</h3><p style="color: #999; margin: 0 0 15px 0; font-size: 24px; font-weight: bold;">$99.99</p><a href="#" style="background: #667eea; color: white; padding: 12px 24px; text-decoration: none; border-radius: 8px; display: inline-block; font-weight: bold; width: 100%; text-align: center; box-sizing: border-box;">Buy Now</a></div></div>' },
        { id: 'countdown', label: 'Countdown', icon: <Schedule />, content: '<div style="background: linear-gradient(45deg, #ff6b6b, #ee5a24); padding: 30px; text-align: center; border-radius: 15px; margin: 30px 0;"><h3 style="color: white; margin: 0 0 20px 0; font-size: 24px;">Limited Time Offer!</h3><div style="display: flex; justify-content: center; gap: 15px;"><div style="background: rgba(255,255,255,0.2); padding: 15px; border-radius: 10px; min-width: 60px;"><div style="color: white; font-size: 24px; font-weight: bold;">03</div><div style="color: white; font-size: 12px;">DAYS</div></div><div style="background: rgba(255,255,255,0.2); padding: 15px; border-radius: 10px; min-width: 60px;"><div style="color: white; font-size: 24px; font-weight: bold;">14</div><div style="color: white; font-size: 12px;">HOURS</div></div><div style="background: rgba(255,255,255,0.2); padding: 15px; border-radius: 10px; min-width: 60px;"><div style="color: white; font-size: 24px; font-weight: bold;">25</div><div style="color: white; font-size: 12px;">MIN</div></div></div></div>' }
      ]
    },
    {
      category: 'Structure',
      items: [
        { id: 'header', label: 'Header', icon: <ViewModule />, content: '<div style="background: #2c3e50; color: white; padding: 20px; text-align: center;"><div style="max-width: 600px; margin: 0 auto;"><h1 style="margin: 0; font-size: 28px; font-weight: 300;">Your Company</h1><p style="margin: 10px 0 0 0; opacity: 0.8;">Tagline goes here</p></div></div>' },
        { id: 'footer', label: 'Footer', icon: <ViewModule />, content: '<div style="background: #34495e; color: white; padding: 40px 20px; text-align: center;"><div style="margin-bottom: 20px;"><a href="#" style="color: white; text-decoration: none; margin: 0 15px;">Privacy Policy</a><a href="#" style="color: white; text-decoration: none; margin: 0 15px;">Terms of Service</a><a href="#" style="color: white; text-decoration: none; margin: 0 15px;">Unsubscribe</a></div><p style="margin: 20px 0 0 0; opacity: 0.7; font-size: 14px;">&copy; 2024 Your Company Name. All rights reserved.<br>123 Business Street, City, State 12345</p></div>' },
        { id: 'divider', label: 'Divider', icon: <DividerIcon />, content: '<div style="text-align: center; margin: 40px 0;"><div style="display: inline-block; width: 100px; height: 2px; background: linear-gradient(45deg, #667eea, #764ba2); border-radius: 1px;"></div></div>' }
      ]
    }
  ]

  const speedDialActions = [
    { icon: <Preview />, name: 'Preview', action: () => handlePreview() },
    { icon: <Save />, name: 'Save', action: () => setSaveDialogOpen(true) },
    { icon: <Send />, name: 'Send', action: () => setSendDialogOpen(true) },
    { icon: <GetApp />, name: 'Export', action: () => exportHTML() }
  ]

  useEffect(() => {
    if (editorRef.current && !editor) {
      const grapesEditor = grapesjs.init({
        container: editorRef.current,
        width: 'auto',
        height: '100%',
        storageManager: false,
        deviceManager: {
          devices: [
            { name: 'Desktop', width: '' },
            { name: 'Tablet', width: '768px', widthMedia: '768px' },
            { name: 'Mobile', width: '320px', widthMedia: '480px' }
          ]
        },
        blockManager: {
          appendTo: '#blocks'
        },
        layerManager: {
          appendTo: '#layers'
        },
        styleManager: {
          appendTo: '#styles',
          sectors: [
            {
              name: 'Typography',
              open: true,
              buildProps: ['font-family', 'font-size', 'font-weight', 'letter-spacing', 'color', 'line-height', 'text-align', 'text-decoration'],
            },
            {
              name: 'Layout',
              open: false,
              buildProps: ['width', 'height', 'max-width', 'min-height', 'margin', 'padding', 'display', 'flex-direction', 'justify-content', 'align-items'],
            },
            {
              name: 'Background',
              open: false,
              buildProps: ['background-color', 'background-image', 'background-size', 'background-position', 'background-repeat'],
            },
            {
              name: 'Border',
              open: false,
              buildProps: ['border', 'border-radius', 'box-shadow'],
            },
            {
              name: 'Effects',
              open: false,
              buildProps: ['opacity', 'transform', 'transition'],
            }
          ]
        },
        canvas: {
          styles: [`
            * { box-sizing: border-box; }
            body { margin: 0; font-family: 'Segoe UI', Arial, sans-serif; }
            .email-container { 
              max-width: 600px; 
              margin: 0 auto; 
              background: white;
              box-shadow: 0 4px 20px rgba(0,0,0,0.1);
            }
            a { transition: all 0.3s ease; }
            a:hover { transform: translateY(-2px); }
            @media (max-width: 480px) {
              .email-container { margin: 0 10px; }
              h1 { font-size: 24px !important; }
              h2 { font-size: 20px !important; }
              .two-column, .three-column { flex-direction: column !important; }
              .two-column > div, .three-column > div { margin: 10px 0 !important; }
            }
          `]
        }
      })

      // Add custom blocks
      advancedBlocks.forEach(category => {
        category.items.forEach(block => {
          grapesEditor.BlockManager.add(block.id, {
            label: block.label,
            content: block.content,
            category: category.category
          })
        })
      })

      // Set initial content
      grapesEditor.setComponents(templates[0].content)

      // Add undo/redo functionality
      grapesEditor.UndoManager.add()

      setEditor(grapesEditor)
    }
  }, [editor])

  const handleBlockClick = (content) => {
    if (editor) {
      editor.addComponents(content)
    }
  }

  const handlePreview = () => {
    if (editor) {
      const html = editor.getHtml()
      const css = editor.getCss()
      const previewWindow = window.open('', '_blank')
      previewWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Email Preview</title>
          <style>${css}</style>
        </head>
        <body>${html}</body>
        </html>
      `)
    }
  }

  const exportHTML = () => {
    if (editor) {
      const html = editor.getHtml()
      const css = editor.getCss()
      const fullHTML = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${emailSettings.subject}</title>
  <style>${css}</style>
</head>
<body>${html}</body>
</html>`
      
      const blob = new Blob([fullHTML], { type: 'text/html' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'email-template.html'
      a.click()
      
      setSnackbarMessage('Email template exported successfully!')
      setSnackbarOpen(true)
    }
  }

  const clearCanvas = () => {
    if (editor) {
      editor.setComponents('')
      setSnackbarMessage('Canvas cleared')
      setSnackbarOpen(true)
    }
  }

  const loadTemplate = (template) => {
    if (editor) {
      editor.setComponents(template.content)
      setTemplateDialogOpen(false)
      setSnackbarMessage(`${template.name} template loaded!`)
      setSnackbarOpen(true)
    }
  }

  const handleUndo = () => {
    if (editor) {
      editor.UndoManager.undo()
    }
  }

  const handleRedo = () => {
    if (editor) {
      editor.UndoManager.redo()
    }
  }

  const handleDeviceChange = (device) => {
    if (editor) {
      editor.setDevice(device)
      setPreviewMode(device.toLowerCase())
    }
  }

  return (
    <Box sx={{ display: 'flex', height: '100vh', bgcolor: '#f5f5f5' }}>
      {/* Left Sidebar */}
      <Drawer
        variant="persistent"
        open={leftPanelOpen}
        sx={{
          width: leftPanelOpen ? 320 : 0,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: 320,
            boxSizing: 'border-box',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            borderRight: 'none'
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
            <Email sx={{ mr: 1, fontSize: 28 }} />
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Email Builder Pro
            </Typography>
            <IconButton 
              sx={{ ml: 'auto', color: 'white' }}
              onClick={() => setLeftPanelOpen(false)}
            >
              <Close />
            </IconButton>
          </Box>

          <Tabs
            value={activeTab}
            onChange={(e, newValue) => setActiveTab(newValue)}
            sx={{
              mb: 2,
              '& .MuiTab-root': { 
                color: 'rgba(255,255,255,0.7)',
                minHeight: 40,
                textTransform: 'none'
              },
              '& .Mui-selected': { color: 'white !important' },
              '& .MuiTabs-indicator': { backgroundColor: 'white' }
            }}
          >
            <Tab label="Blocks" />
            <Tab label="Templates" />
            <Tab label="Settings" />
          </Tabs>

          {activeTab === 0 && (
            <Box sx={{ maxHeight: 'calc(100vh - 200px)', overflow: 'auto' }}>
              {advancedBlocks.map((category, categoryIndex) => (
                <Box key={categoryIndex} sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600, opacity: 0.9 }}>
                    {category.category}
                  </Typography>
                  <Grid container spacing={1}>
                    {category.items.map((block, blockIndex) => (
                      <Grid item xs={6} key={blockIndex}>
                        <Card
                          sx={{
                            cursor: 'pointer',
                            bgcolor: 'rgba(255,255,255,0.1)',
                            color: 'white',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                              bgcolor: 'rgba(255,255,255,0.2)',
                              transform: 'translateY(-2px)'
                            }
                          }}
                          onClick={() => handleBlockClick(block.content)}
                        >
                          <CardContent sx={{ p: 2, textAlign: 'center' }}>
                            {block.icon}
                            <Typography variant="caption" sx={{ display: 'block', mt: 1 }}>
                              {block.label}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              ))}
            </Box>
          )}

          {activeTab === 1 && (
            <Box sx={{ maxHeight: 'calc(100vh - 200px)', overflow: 'auto' }}>
              <Button
                variant="contained"
                fullWidth
                sx={{ 
                  mb: 2, 
                  bgcolor: 'rgba(255,255,255,0.2)',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' }
                }}
                onClick={() => setTemplateDialogOpen(true)}
              >
                Browse Templates
              </Button>
              {templates.map((template, index) => (
                <Card
                  key={index}
                  sx={{
                    mb: 2,
                    cursor: 'pointer',
                    bgcolor: 'rgba(255,255,255,0.1)',
                    color: 'white',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      bgcolor: 'rgba(255,255,255,0.2)',
                      transform: 'translateY(-2px)'
                    }
                  }}
                  onClick={() => loadTemplate(template)}
                >
                  <CardContent>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      {template.name}
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.8 }}>
                      {template.description}
                    </Typography>
                  </CardContent>
                </Card>
              ))}
            </Box>
          )}

          {activeTab === 2 && (
            <Box sx={{ maxHeight: 'calc(100vh - 200px)', overflow: 'auto' }}>
              <TextField
                fullWidth
                label="Subject Line"
                value={emailSettings.subject}
                onChange={(e) => setEmailSettings({...emailSettings, subject: e.target.value})}
                sx={{ 
                  mb: 2,
                  '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.7)' },
                  '& .MuiOutlinedInput-root': { 
                    color: 'white',
                    '& fieldset': { borderColor: 'rgba(255,255,255,0.3)' },
                    '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.5)' },
                    '&.Mui-focused fieldset': { borderColor: 'white' }
                  }
                }}
              />
              <TextField
                fullWidth
                label="Preheader Text"
                value={emailSettings.preheader}
                onChange={(e) => setEmailSettings({...emailSettings, preheader: e.target.value})}
                sx={{ 
                  mb: 2,
                  '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.7)' },
                  '& .MuiOutlinedInput-root': { 
                    color: 'white',
                    '& fieldset': { borderColor: 'rgba(255,255,255,0.3)' },
                    '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.5)' },
                    '&.Mui-focused fieldset': { borderColor: 'white' }
                  }
                }}
              />
              <TextField
                fullWidth
                label="From Name"
                value={emailSettings.fromName}
                onChange={(e) => setEmailSettings({...emailSettings, fromName: e.target.value})}
                sx={{ 
                  mb: 2,
                  '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.7)' },
                  '& .MuiOutlinedInput-root': { 
                    color: 'white',
                    '& fieldset': { borderColor: 'rgba(255,255,255,0.3)' },
                    '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.5)' },
                    '&.Mui-focused fieldset': { borderColor: 'white' }
                  }
                }}
              />
              <TextField
                fullWidth
                label="From Email"
                value={emailSettings.fromEmail}
                onChange={(e) => setEmailSettings({...emailSettings, fromEmail: e.target.value})}
                sx={{ 
                  mb: 2,
                  '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.7)' },
                  '& .MuiOutlinedInput-root': { 
                    color: 'white',
                    '& fieldset': { borderColor: 'rgba(255,255,255,0.3)' },
                    '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.5)' },
                    '&.Mui-focused fieldset': { borderColor: 'white' }
                  }
                }}
              />
            </Box>
          )}
        </Box>
      </Drawer>

      {/* Main Content */}
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        {/* Top Bar */}
        <AppBar position="static" sx={{ bgcolor: 'white', color: '#333', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
          <Toolbar>
            {!leftPanelOpen && (
              <IconButton onClick={() => setLeftPanelOpen(true)}>
                <MenuOpen />
              </IconButton>
            )}
            <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 600 }}>
              {emailSettings.subject}
            </Typography>
            
            {/* Device Preview Buttons */}
            <Box sx={{ display: 'flex', mr: 2 }}>
              <Tooltip title="Desktop View">
                <IconButton 
                  color={previewMode === 'desktop' ? 'primary' : 'default'}
                  onClick={() => handleDeviceChange('Desktop')}
                >
                  <Computer />
                </IconButton>
              </Tooltip>
              <Tooltip title="Tablet View">
                <IconButton 
                  color={previewMode === 'tablet' ? 'primary' : 'default'}
                  onClick={() => handleDeviceChange('Tablet')}
                >
                  <Tablet />
                </IconButton>
              </Tooltip>
              <Tooltip title="Mobile View">
                <IconButton 
                  color={previewMode === 'mobile' ? 'primary' : 'default'}
                  onClick={() => handleDeviceChange('Mobile')}
                >
                  <Smartphone />
                </IconButton>
              </Tooltip>
            </Box>

            <Box sx={{ display: 'flex', gap: 1 }}>
              <Tooltip title="Undo">
                <IconButton onClick={handleUndo}>
                  <Undo />
                </IconButton>
              </Tooltip>
              <Tooltip title="Redo">
                <IconButton onClick={handleRedo}>
                  <Redo />
                </IconButton>
              </Tooltip>
              <Tooltip title="Preview">
                <IconButton onClick={handlePreview}>
                  <Preview />
                </IconButton>
              </Tooltip>
              <Button
                variant="outlined"
                startIcon={<Clear />}
                onClick={clearCanvas}
                sx={{ mr: 1 }}
              >
                Clear
              </Button>
              <Button
                variant="contained"
                startIcon={<GetApp />}
                onClick={exportHTML}
                sx={{ 
                  background: 'linear-gradient(45deg, #667eea, #764ba2)',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #5a6fd8, #6a4190)'
                  }
                }}
              >
                Export
              </Button>
            </Box>
          </Toolbar>
        </AppBar>

        {/* Editor Area */}
        <Box sx={{ display: 'flex', flex: 1 }}>
          <Box ref={editorRef} sx={{ flex: 1, bgcolor: 'white' }} />
          
          {/* Right Panel */}
          {rightPanelOpen && (
            <Paper
              elevation={3}
              sx={{
                width: 350,
                borderLeft: '1px solid #e0e0e0',
                display: 'flex',
                flexDirection: 'column',
                bgcolor: '#fafafa'
              }}
            >
              <Box sx={{ 
                p: 2, 
                borderBottom: '1px solid #e0e0e0',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Properties Panel
                </Typography>
                <IconButton 
                  sx={{ color: 'white' }}
                  onClick={() => setRightPanelOpen(false)}
                >
                  <Close />
                </IconButton>
              </Box>
              
              <Box sx={{ p: 2, flex: 1, overflow: 'auto' }}>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                    <Layers sx={{ mr: 1 }} /> Layers
                  </Typography>
                  <Box 
                    id="layers" 
                    sx={{ 
                      height: 250, 
                      overflow: 'auto', 
                      border: '1px solid #e0e0e0',
                      borderRadius: 2,
                      bgcolor: 'white',
                      p: 1
                    }} 
                  />
                </Box>
                
                <Box>
                  <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                    <Style sx={{ mr: 1 }} /> Styles
                  </Typography>
                  <Box 
                    id="styles" 
                    sx={{ 
                      border: '1px solid #e0e0e0',
                      borderRadius: 2,
                      bgcolor: 'white',
                      overflow: 'auto',
                      maxHeight: 400
                    }} 
                  />
                </Box>
              </Box>
            </Paper>
          )}

          {!rightPanelOpen && (
            <Fab
              color="primary"
              size="small"
              sx={{ 
                position: 'fixed',
                right: 20,
                top: 100,
                background: 'linear-gradient(45deg, #667eea, #764ba2)'
              }}
              onClick={() => setRightPanelOpen(true)}
            >
              <Style />
            </Fab>
          )}
        </Box>
      </Box>

      {/* Speed Dial */}
      <SpeedDial
        ariaLabel="Actions"
        sx={{ position: 'fixed', bottom: 20, right: 20 }}
        icon={<SpeedDialIcon />}
        FabProps={{
          sx: {
            background: 'linear-gradient(45deg, #667eea, #764ba2)',
            '&:hover': {
              background: 'linear-gradient(45deg, #5a6fd8, #6a4190)'
            }
          }
        }}
      >
        {speedDialActions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={action.action}
          />
        ))}
      </SpeedDial>

      {/* Template Dialog */}
      <Dialog 
        open={templateDialogOpen} 
        onClose={() => setTemplateDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white'
        }}>
          Choose a Template
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            {templates.map((template, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Card
                  sx={{
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 8px 30px rgba(0,0,0,0.15)'
                    }
                  }}
                  onClick={() => loadTemplate(template)}
                >
                  <Box
                    sx={{
                      height: 150,
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white'
                    }}
                  >
                    <Reorder sx={{ fontSize: 48 }} />
                  </Box>
                  <CardContent>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      {template.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {template.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setTemplateDialogOpen(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Save Dialog */}
      <Dialog open={saveDialogOpen} onClose={() => setSaveDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Save Template</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Template Name"
            sx={{ mt: 2, mb: 2 }}
            placeholder="Enter template name..."
          />
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Description"
            placeholder="Optional description..."
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSaveDialogOpen(false)}>Cancel</Button>
          <Button 
            variant="contained" 
            onClick={() => {
              setSaveDialogOpen(false)
              setSnackbarMessage('Template saved successfully!')
              setSnackbarOpen(true)
            }}
          >
            Save Template
          </Button>
        </DialogActions>
      </Dialog>

      {/* Send Dialog */}
      <Dialog open={sendDialogOpen} onClose={() => setSendDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Send Email Campaign</DialogTitle>
        <DialogContent>
          <Alert severity="info" sx={{ mb: 2 }}>
            Configure your email campaign settings before sending.
          </Alert>
          <TextField
            fullWidth
            label="Campaign Name"
            sx={{ mb: 2 }}
            placeholder="Enter campaign name..."
          />
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Audience</InputLabel>
            <Select defaultValue="">
              <MenuItem value="all">All Subscribers</MenuItem>
              <MenuItem value="active">Active Subscribers</MenuItem>
              <MenuItem value="segment1">Segment 1</MenuItem>
              <MenuItem value="segment2">Segment 2</MenuItem>
            </Select>
          </FormControl>
          <FormControlLabel
            control={<Switch />}
            label="Schedule for later"
            sx={{ mb: 1 }}
          />
          <TextField
            fullWidth
            type="datetime-local"
            label="Send Date & Time"
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSendDialogOpen(false)}>Cancel</Button>
          <Button 
            variant="contained" 
            startIcon={<Send />}
            onClick={() => {
              setSendDialogOpen(false)
              setSnackbarMessage('Email campaign scheduled successfully!')
              setSnackbarOpen(true)
            }}
          >
            Send Campaign
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert severity="success" onClose={() => setSnackbarOpen(false)}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  )
}

export default AdvancedEmailBuilder;